export default __webpack_public_path__ + "assets/13d.aa9fe108.svg";